import { render } from "./chartMapping.vue?vue&type=template&id=b89c2c16&scoped=true"
import script from "./chartMapping.vue?vue&type=script&lang=js"
export * from "./chartMapping.vue?vue&type=script&lang=js"

import "./chartMapping.vue?vue&type=style&index=0&id=b89c2c16&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b89c2c16"]])

export default __exports__